var angular = require('angular');
var _module = require('../module');


_module.component('widgetContainer', {
    controllerAs: 'widgetCtrl',
    controller: [
        '$log',
        '$window',

        function widgetCtrl($log, $window) {
        }
    ],
    template: require('./index.html')
});
